export const homePageGroupPic = {
  imageSrc: 'donation/home/group-pic-latest.png',
  mediaQuery: [
    { screen: '(max-width: 1023px)', width: '316px' },
    { screen: '(min-width: 1024px)', width: '474px' },
  ],
  imageAlt: 'Math Magic for Ukraine group pic',
}
